// extracted by mini-css-extract-plugin
module.exports = {"loader-wrap":"Loader_loader-wrap__eyw71","position-absolute":"Loader_position-absolute__Yu7FJ","flex-center":"Loader_flex-center__RfJXI","hor-center":"Loader_hor-center__isD_p"};